export const konutIsyeriPage = () => `
  <section class="page-content service-page">
    <div class="container">
      <div class="service-header">
        <h1 class="page-title">Konut ve İşyeri Sigortaları</h1>
        <p class="page-subtitle">Evinizi ve işyerinizi yangın, deprem, hırsızlık ve doğal afetlere karşı güvence altına alıyoruz.</p>
      </div>

      <div class="service-list">
        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
          </div>
          <div class="service-info">
            <h3>Konut Sigortası</h3>
            <p>Evinizi ve eşyalarınızı yangın, su baskını, hırsızlık, fırtına ve doğal afetlere karşı kapsamlı şekilde koruma altına alır. Bina ve eşya teminatları ayrı ayrı belirlenebilir.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <img src="/icons/dask.png" alt="DASK">
          </div>
          <div class="service-info">
            <h3>DASK (Zorunlu Deprem Sigortası)</h3>
            <p>Türkiye'de belediye sınırları içindeki tüm konutlar için zorunlu olan deprem sigortasıdır. Deprem ve depreme bağlı yangın, tsunami gibi riskleri karşılar.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path></svg>
          </div>
          <div class="service-info">
            <h3>İşyeri Sigortası</h3>
            <p>İşyerinizi, demirbaşlarınızı ve stoklarınızı yangın, hırsızlık, su baskını ve doğal afetlere karşı korur. İş durması teminatı da eklenebilir.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
          </div>
          <div class="service-info">
            <h3>Yangın Sigortası</h3>
            <p>Bina ve muhteviyatınızı yangın, yıldırım, infilak risklerine karşı teminat altına alır. Ek teminatlar ile daha geniş koruma sağlanabilir.</p>
          </div>
        </div>

        <div class="service-item">
          <div class="service-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="48" height="48"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
          </div>
          <div class="service-info">
            <h3>Hırsızlık & Cam Kırılması Teminatı</h3>
            <p>Konut ve işyerlerinde hırsızlık, cebir ile gasp ve cam kırılması risklerini karşılayan ek teminat seçenekleri sunuyoruz.</p>
          </div>
        </div>
      </div>

      <div class="service-cta">
        <h2>Eviniz ve İşyeriniz İçin Teklif Alın</h2>
        <p>DASK'tan konut sigortasına, işyerinden yangın sigortasına — ihtiyacınıza uygun poliçeyi bulalım.</p>
        <a href="/teklif-al" class="btn-primary">Hemen Teklif Al</a>
      </div>
    </div>
  </section>
`;
